// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"319":"static-consents","482":"fanatical-consents"}[chunkId] + ".js";
};